import React, { Fragment } from 'react';
import { IsValidSessionSwitch, GetStateStorage } from 'common/storage';
import { isMissionStatementSelected } from 'common/helpers/profileCompleteness';
import { noteUtils } from '../Notes/Common/NoteUtils';
import { Button, Typography } from '@mui/material';
import classNames from 'classnames';
import { NotesCameFrom } from '../Notes/Common/NotesConfig';
import { renderLogicUtil } from 'views/Pma/RenderLogicUtil';
import { MailProConstants } from '../../PmaMailingList/MailProConstants';
import { useNavigate } from 'react-router-dom';


export const ApproveMailingListPendingActions = ({ children, hoFilter, propertyData, mode, classes, currentArea = null, ...rest }) => {
    const navigate = useNavigate();

    const handleNewMailingClickButtons = (mode) => {
        rest.handleClose();
        // Reset showConfirmationDialog in NavbarFilterBox so the next approval
        // click creates a fresh ApproveMailingListDialog (open=true) instead of
        // reusing the stale mounted instance that has internal open=false.
        rest.continueEditingModeFn && rest.continueEditingModeFn();
        rest.explicitEnableNewMailProInitFn(true);
        mode !== MailProConstants.newAnniversary && rest.disableNewMailingForCurrentSessionFn(false);
        rest.setNewMailProInitDialogModeFn(mode);
    };

    const newMailingHOPropertiesCount = renderLogicUtil.countMailProInitProperties(
        propertyData,
        true,
        MailProConstants.newMailing,
    );

    const newlyConstructedHOPropertiesCount = renderLogicUtil.countMailProInitProperties(
        propertyData,
        true,
        MailProConstants.isNewProperty
    );
    const isSessionSwitch = IsValidSessionSwitch();
    const anyNewPropertyorHOPending = (newMailingHOPropertiesCount > 0 || newlyConstructedHOPropertiesCount > 0) && !isSessionSwitch;
    const anyHomeownerHavingPendingAnniversaryNoteCount = (noteUtils.getAllPropertiesPendingAnniversaryNoteswrtHOFilter(propertyData, NotesCameFrom.Anniversary, hoFilter) || []).length ;//0
    //disabling this
    const anyHomeownerHavingPendingAnniversaryNote = anyHomeownerHavingPendingAnniversaryNoteCount > 0 ;//false

    // Pending anniversary notes / new homeowners take priority; the mission statement check comes last.
    // Driven only by the IsMissionStatementSelected flag on the agent profile.
    const { userData } = GetStateStorage() || {};
    const missionAreaID = currentArea && currentArea.mlsAreaID ? currentArea.mlsAreaID : null;
    const anyMissionStatementPending = !!userData && !isMissionStatementSelected(userData);

    const handleUpdateMissionStatementClick = () => {
        rest.handleClose();
        rest.continueEditingModeFn && rest.continueEditingModeFn();
        navigate(missionAreaID ? `/agent/missionstatements/${missionAreaID}` : '/agent/missionstatements');
    };

    const getBody = () => {
        return anyHomeownerHavingPendingAnniversaryNote ?

            <Fragment>
                <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                    Please Note:
                </Typography>
                <br />
                <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                    You have {anyHomeownerHavingPendingAnniversaryNoteCount} NEW Homeowner{anyHomeownerHavingPendingAnniversaryNoteCount > 1 ? 's' : ''} that you can send a Happy Anniversary Note to.
                </Typography>
                <br />
                <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                    Before you can approve this mailing, you must finish sending your {anyHomeownerHavingPendingAnniversaryNoteCount} Homeowner{anyHomeownerHavingPendingAnniversaryNoteCount > 1 ? 's' : ''} a Happy Anniversary Note.
                </Typography>
            </Fragment>

            : anyNewPropertyorHOPending ?
                <Fragment>
                    <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                        Please Note:
                    </Typography>
                    <br />
                    {newMailingHOPropertiesCount > 0 ?
                        <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                            You have {newMailingHOPropertiesCount} NEW Homeowner{newMailingHOPropertiesCount > 1 ? 's' : ''} that have moved into your area.
                        </Typography>
                        :
                        <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                            You have {newlyConstructedHOPropertiesCount} NEW {newlyConstructedHOPropertiesCount > 0 ? 'Properties' : 'Property'} that can be added to your MailPro mailing list.
                        </Typography>}
                    <br />
                    <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                        Before you can APPROVE this PMA you must review and/or Personalize these Homeowner's names.
                    </Typography>
                </Fragment>

                : anyMissionStatementPending ?
                    <Fragment>
                        <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                            Please Note:
                        </Typography>
                        <br />
                        <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                            You have not selected a valid Mission Statement yet.
                        </Typography>
                        <br />
                        <Typography variant="subtitle2" align="center" className={classNames(classes.redColor, classes.boldFont)}>
                            Please edit all the flashing text (XX or [brackets]) and select your Mission Statement before approving your area.
                        </Typography>
                    </Fragment>

                    : children;
    }

    const getFooter = () => {
        return anyHomeownerHavingPendingAnniversaryNote ?
            <div className={classes.footerButtons}>
                <div className={classes.footerButtonsLeftRight}></div>
                <div className={classes.footerButtonsCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.finishedButton}
                        onClick={event => { handleNewMailingClickButtons(MailProConstants.newAnniversary) }}
                    >
                        Click here to Send or Skip Anniversary Notes
                    </Button>
                </div>
                <div className={classes.footerButtonsLeftRight}></div>
            </div>
            :

            anyNewPropertyorHOPending ? <div className={classes.footerButtons}>
                <div className={classes.footerButtonsLeftRight}></div>
                <div className={classes.footerButtonsCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.finishedButton}
                        onClick={event => { handleNewMailingClickButtons(newMailingHOPropertiesCount > 0 ? MailProConstants.newMailing : MailProConstants.isNewProperty) }}
                    >
                        CLICK HERE TO PERSONALIZE MY NEW {newMailingHOPropertiesCount > 0 ?
                            (newMailingHOPropertiesCount > 1 ? 'HOMEOWNERS' : 'HOMEOWNER')
                            : (newlyConstructedHOPropertiesCount > 1 ? 'PROPERTIES' : 'PROPERTY')}
                    </Button>
                </div>
                <div className={classes.footerButtonsLeftRight}></div>
            </div>

            : anyMissionStatementPending ? <div className={classes.footerButtons}>
                <div className={classes.footerButtonsLeftRight}></div>
                <div className={classes.footerButtonsCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.finishedButton}
                        onClick={handleUpdateMissionStatementClick}
                    >
                        UPDATE MISSION STATEMENT
                    </Button>
                </div>
                <div className={classes.footerButtonsLeftRight}></div>
            </div> : children;
    }


    return mode === 'body' ? getBody() : getFooter()
}